import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

export default function LatestUpdates() {
  const latestMovies = movies.filter((m) => m.isNew).slice(0, 8);

  return (
    <section className="py-12 md:py-16">
      <div className="site-container">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">刚上线的热门内容</p>
          </div>
          <Link
            to="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            更多新片
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>
      </div>
    </section>
  );
}